import { emergencyStopExperimentEpic } from "../components/Shutdown/Shutdown.epics.js";
const rootEpic = emergencyStopExperimentEpic;
export {
  rootEpic as default,
  rootEpic
};
//# sourceMappingURL=epics.js.map
